import {Notification} from 'element-ui';
// Initial state
const state = {
	user: null,
    roles: []
};

// Getters
const getters = {
    userFullName: state => state.user && state.user.full_name ? state.user.full_name : '',
    roles: state => state.user.roles && state.user.roles ? state.user.roles : [],
};

// Actions
const actions = {
    setLogOut({state, commit, dispatch}) {

        Notification.closeAll();
        dispatch('loading/spinner', {msg: 'Cerrando sesión...', status: true}, {root: true});

        return axios.post('/api/logout')
            .then(response => {
                dispatch('loading/spinner', {}, {root: true});

                if (response.data.authenticated === false) {

                    window.sessionStorage.removeItem('sr_young_token');
                    window.axios.defaults.headers.common = {
                        'Authorization': 'Bearer'
                    };
                    commit('deleteUser');

                    return Promise.resolve(true);

                } else {
                    dispatch('loading/spinner', {}, {root: true});
                    dispatch('notifications/warning', {msg: 'Existió un error al intentar cerarr la sesión.'}, {root: true});
                    return Promise.reject(false);
                }
            }).catch((err) => {
                console.log(err);
                return Promise.reject(err);
            });
    }
};

// Mutations
const mutations = {
	setUser: (state, user) => {
		state.user		= user;
        state.roles = user.roles;
	},
	deleteUser: state => {
        state.user		= null;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
}
